import { render, staticRenderFns } from "./DefaultMailNewInvoice.vue?vue&type=template&id=17c21fa4&"
import script from "./DefaultMailNewInvoice.vue?vue&type=script&lang=js&"
export * from "./DefaultMailNewInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports